export const FROM_12AM_TO_5AM = 'FROM_12AM_TO_5AM';
export const FROM_5AM_TO_3PM = 'FROM_5AM_TO_3PM';
export const FROM_5AM_TO_6AM = 'FROM_5AM_TO_6AM';
export const FROM_6AM_TO_9AM = 'FROM_6AM_TO_9AM';

export const FROM_9AM_TO_5PM = 'FROM_9AM_TO_5PM';
export const FROM_3PM_TO_6PM = 'FROM_3PM_TO_6PM';
export const FROM_6PM_TO_12AM = 'FROM_6PM_TO_12AM';
export const FROM_5PM_TO_8PM = 'FROM_5PM_TO_8PM';
export const FROM_8PM_TO_12AM = 'FROM_8PM_TO_12PM';
export const FROM_5PM_TO_12AM = 'FROM_5PM_TO_12AM';
export const ALL_HOURS = 'ALL_HOURS';
